import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import dot from 'dot-object';
import cloneDeep from 'lodash/cloneDeep';
import core from '@/modules/core/common/store';
import lowCode from '@/modules/low-code/common/store';
import info from '@/modules/logito/staff/store';
import calendar from '@/modules/logito/calendar/store';
import office from '@/modules/logito/office/store';
import finance from '@/modules/low-code/common/store/descriptionTemplates';
import actions from '@/modules/low-code/common/store/actions';

export default createStore({
    strict: false,
    modules: {
        ...core,
        ...info,
        ...office,
        ...calendar,
        ...lowCode,
        ...finance,
        actions
    },
    plugins: [
        createPersistedState({
            reducer: (persistedState: any) =>
            {
                const stateFilter = {};
                const states: Array<string> = []; // states which we want to persist.

                states.forEach(path => dot.copy(path, path, persistedState, stateFilter));

                return cloneDeep(stateFilter);
            }
        })
    ]
});

declare module "@vue/runtime-core"
{
    interface ComponentCustomProperties
    {
        $store: any;
    }
}
